import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { IUser } from '../../../../shared/models/user.model';
import {
  FundraiserService, StorageService, UtilService, VariablesService, SignupService, EventsService
} from '../../../../shared/services';

@Component({
  selector: 'app-comment-card',
  templateUrl: './comment-card.component.html',
  styleUrls: ['./comment-card.component.scss']
})
export class CommentCardComponent implements OnInit, OnDestroy {

  isMobile: any;
  @Input() public comments;
  @Input() public campaignId;
  @Input() public updateId;
  @Input() public header = true;
  @Input() public reactionType;
  @Input() public updateTypeColor;
  @Input() public count;
  @Input() public parentId;
  @Input() public origin;
  @Input() public customTag;
  @Input() public postCommentLabel;
  @Input() public pageName;
  @Input() public update;
  @Input() public showComments = true;
  @Input() public tabSwitch;
  @Input() public orderId;
  @Input() public showCommentList = true;

  @Output() public isCommentVisible = new EventEmitter();
  @Output() public commentPosted = new EventEmitter<any>();
  @Output() public updateReact = new EventEmitter<any>();

  @ViewChild('showMore') showMore: ElementRef<HTMLElement>;
  @ViewChild('loginPopupTemp') loginPopupTemp: ElementRef<HTMLElement>;

  userdata: IUser;
  donor = {
    name: '',
    donoravtar: {}
  };
  isShown = false;
  isShowBtnHide = false;
  isLoggedIn;
  page = 1;
  commentPostInprogess = false;

  commentForm: FormGroup;
  commentInput: FormControl;
  // Subscriptions
  userdataSubs: Subscription;
  isLoggedInSubs: Subscription;
  constructor(
    public utilService: UtilService,
    public storageService: StorageService,
    public fundraiserService: FundraiserService,
    public variablesService: VariablesService,
    @Inject(DOCUMENT) public document: any,
    private cdr: ChangeDetectorRef,
    private signupService: SignupService,
    public events: EventsService
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
    this.getUserDetails();
    this.checkForLogin();
    this.formInit();
  }

  /**To show whether post comment is in view*/
  postCommentInView(event) {
    this.isCommentVisible.emit(event.visible);
  }

  /**Init The form */
  formInit() {
    this.commentForm = new FormGroup({
      commentInput: this.commentInput = new FormControl('', [Validators.required, Validators.maxLength(500)])
    });
  }
  autosize() {
    if (this.pageName === 'updatesPage' && this.utilService.isMobile()) {
      const el: HTMLElement = this.document.querySelector('.comment-banner-area .cm-input');
      setTimeout(function () {
        if (Number(el.clientHeight) <= el.scrollHeight) {
          el.style.cssText = 'height:auto; padding:0';
          el.style.cssText = 'height:' + el.scrollHeight + 'px !important';
        } else {
          el.style.cssText = 'height:auto; padding:0';
          el.style.cssText = 'height:' + Number(el.clientHeight) + 'px !important';
        }
      }, 0);
    }
  }
  /**Check for login */
  checkForLogin() {
    this.utilService.isLoggedIn$.subscribe(res => this.isLoggedIn = res);
  }
  /**Add class for show more effect*/
  addClass() {
    if (this.comments && this.comments.data.length >= 4) {
      this.isShowBtnHide = false;
      const el: HTMLElement = this.showMore.nativeElement;
      el.classList.add('show-more-effect');
    }
  }
  /**Toggle class for show more */
  toggleClass() {
    // if (this.tabSwitch && this.isMobile) {
    //   this.variablesService.commentTabSwitch.next('Comments');
    // }
    let custom_tag;
    if (this.page === this.comments.last_page) {
      this.isShowBtnHide = true;
    } else {
      this.page++;
      if (this.variablesService.fundraiser.main_custom_tag) {
        custom_tag = this.variablesService.fundraiser.main_custom_tag;
      } else {
        custom_tag = this.variablesService.fundraiser.custom_tag;
      }
      if (this.origin === 'update') {
        this.getUpdatesCommnets(custom_tag, '5', this.page);
      } else if (this.origin === 'stories') {
        this.getFundraiserCommnets(custom_tag, '5', this.page);
      } else {
        this.getFundraiserCommnets(custom_tag, '10', this.page);
      }
      this.isShowBtnHide = this.page === this.comments.last_page ? true : false;
    }
  }

  /**Set Name Initials  */
  setName(name: string) {
    return this.utilService.getInitialsOfName(name);
  }
  getUserDetails() {
    this.variablesService.userData.subscribe({
      next: (res) => {
        if (res) {
          this.userdata = res;
          this.donor = {
            name: this.userdata.full_name,
            donoravtar: this.userdata.avtar
          };
        } else {
          this.userdata = undefined;
          this.donor = { name: '', donoravtar: {} };
        }
      }
    });
  }
  /**Open Modal/Dialog */
  openDialog() {
    this.signupService.openSignUp(this.loginPopupTemp, 'otp', () => { });
  }
  /**Post Comment */
  postComment() {
    if (this.commentForm.valid) {
      if (this.isLoggedIn) {
        if (this.urlCommentRegex(this.commentInput.value)) {
          this.utilService.openSnackBar('Failed to post comment.', 'error');
          return;
        }
        const payload = {
          'text': this.commentInput.value,
          'type': this.origin,
          'email': this.userdata.email
        };
        if (this.orderId) {
          payload['order_id'] = this.orderId;
        }
        this.commentPostInprogess = true;
        this.postCommentAPI(payload);
      } else {
        this.openDialog();
      }
    }
  }

  urlCommentRegex(input) {
    const expression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
    const regex = new RegExp(expression);
    return input.match(regex);
  }

  /**Post comment */
  postCommentAPI(payload) {
    let source = this.origin;
    if (this.origin === 'stories') {
      source = 'campaign';
      payload['type'] = 'campaign';
    }
    this.events.userGTMEvents({
      event: 'fundraiser_comment',
      event_category: 'fundraiser',
      event_action: 'post comment',
      event_label: this.variablesService.fundraiser.title
    });
    switch (source) {
      case 'campaign':
        this.postCommentOnCampaign(payload);
        break;
      case 'update':
        this.postCommentOnUpdate(payload);
        break;
      default:
        break;
    }
  }
  /**AFter Post Comment */
  afterPostComment(data) {
    this.utilService.openSnackBar('Your comment posted successfully!', 'success');
    this.commentForm.reset();
    this.commentPosted.emit(true);
    const commentData = {
      entity: {
        avtar: this.userdata.avtar,
        full_name: this.userdata.full_name,
        id: this.userdata.id
      },
      text: data.text,
      updation_date: data.updation_date,
      user_id: data.user_id,
      type: data.type,
      creation_date: data.creation_date,
      status: data.status
    };
    this.comments.data.unshift(commentData);
    this.comments.total++;
    this.cdr.detectChanges();
  }
  /**Post cooment on update */
  postCommentOnUpdate(payload) {
    this.fundraiserService.postCommentOnUpdate(this.campaignId, this.updateId, payload).subscribe((res: any) => {
      this.commentPostInprogess = false;
      if (this.showComments) {
        this.afterPostComment(res.data);
      } else {
        this.commentPosted.emit(true);
      }
      this.events.sendSystemEvent({
        eventName: 'commented',
        info_1: this.userdata?.id || '',
      }).subscribe(_=>_);
    }, (error) => {
      this.commentPostInprogess = false;
      if (error.status === 401) {
        this.openDialog();
      }
    });
  }
  /**Post cooment on campaign */
  postCommentOnCampaign(payload) {
    this.fundraiserService.postCommentOnCampaign(this.campaignId, payload).subscribe((res: any) => {
      this.commentPostInprogess = false;
      if (this.showComments) {
        this.afterPostComment(res.data);
      } else {
        this.commentPosted.emit(true);
      }
      this.events.sendSystemEvent({
        eventName: 'commented',
        info_1: this.userdata?.id || '',
      }).subscribe(_=>_);
    }, (error) => {
      this.commentPostInprogess = false;
      if (error.status === 401) {
        this.openDialog();
      }
    });
  }
  /**Get the fundraiser comments */
  getFundraiserCommnets(customTag, limit, page) {
    const qParam = `?limit=${limit}&page=${page}`;
    this.fundraiserService.getFundraiserComments(customTag, qParam).subscribe((res: any) => {
      Array.prototype.push.apply(this.comments.data, res.data.data);
      this.cdr.detectChanges();
      this.comments.from = res.data.from;
      this.comments.last_page = res.data.last_page;
      this.comments.total = res.data.total;
    });
  }
  /**Get the fundraiser comments */
  getUpdatesCommnets(customTag, limit, page) {
    const qParam = `/${this.update.id}/comments?limit=${limit}&page=${page}`;
    this.fundraiserService.getFundraiserUpdates(customTag, qParam).subscribe((res: any) => {
      Array.prototype.push.apply(this.comments.data, res.data.data);
      this.cdr.detectChanges();
      this.comments.from = res.data.from;
      this.comments.last_page = res.data.last_page;
      this.comments.total = res.data.total;
    });
  }
  /**toggle the reation */
  reactOnUpdate(update) {
    this.updateReact.emit(true);
  }

  ngOnDestroy() {
  }

}
